export const EntityLayerFragment = gql`
  fragment EntityLayerFragment on EntityLayer {
    id
    name
    type
  }
`
